import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';

import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import SignUpWrapper from 'containers/SignUpWrapper';
import { TRIAL_SIGNUP_ROUTES, ROUTES, insertIdtoUrl } from 'constants/Routes';
import {
  getNonce,
  getBusinessId,
  getSelectedPlan,
  getBillingDetails,
  setPlanSubscriptionStatus,
} from 'constants/localStorageManager';
import BusinessApi from 'apis/Business';
import squarePayment from 'assets/img/square_payment.png';
import 'assets/scss/soonoGetStarted.css';

import Toaster from '../Toaster';

class ReviewSubscription extends Component {
  constructor() {
    super();
    this.state = {};
  }

  getBillingAddressAttributes = () => {
    const {
      addressLine1: address_line_1,
      addressLine1: address_line_2,
      city,
      state,
      zip,
      country,
    } = getBillingDetails() || {};
    const { nonce, billing_name } = getNonce() || {};
    return {
      address_line_1,
      address_line_2,
      city,
      state,
      zip,
      country,
      billing_name,
      nonce,
      is_primary: true,
    };
  };

  updateBillingDetails = () => {
    const { location, renew } = this.props;

    if (renew) return this.updatePlan();
    return this.changeStep(location.pathname);
  };

  updatePlan = () => {
    const plan_subscription_attributes = getSelectedPlan();
    const billing_addresses_attributes = [this.getBillingAddressAttributes()];

    const updateData = {
      business: {
        plan_subscription_attributes,
        billing_addresses_attributes,
      },
    };

    BusinessApi.update(getBusinessId(), updateData)
      .then(({ data }) => {
        const { plan_subscription } = data;
        setPlanSubscriptionStatus(plan_subscription);
        Toaster.getSuccessToaster('check-circle', 'Successfully updated plan');
        this.changeStep();
      })
      .catch(() => {
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update plan'
        );
      });
  };

  changeStep = currentPathName => {
    const { renew } = this.props;
    const businessId = getBusinessId();
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    const pushUrl = renew
      ? insertIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, businessId)
      : nextStep.path;
    this.props.history.push(pushUrl);
  };

  render() {
    const { location, renew } = this.props;
    const selectedPlan = getSelectedPlan();
    const {
      billing_frequency,
      billing_rate,
      end_date,
      plan_name,
    } = selectedPlan;
    const frequencyText = billing_frequency === 'monthly' ? 'month' : 'year';

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.PAYMENT_REVIEW}
        currentStep={location.pathname}
        renew={renew}
      >
        <div className="col-md-10 offset-md-1 text-left payment-review">
          <h3 className="mt-5 mb-4 text-dark" style={{ fontWeight: 600 }}>
            Review your subscription
          </h3>
          <div className="review-card pt-3">
            <ul className="review-subscription">
              <li>
                Your basic package monthly subscription begins today and ends on{' '}
                <strong>{moment(end_date).format('MMM DD, YYYY')}</strong>.
              </li>
              <li>
                You will be charged ${billing_rate}/{frequencyText} for the{' '}
                {plan_name} package.
              </li>
              <li>
                <strong>
                  The plan will automatically renew each {frequencyText} until
                  cancelled
                </strong>
                . To avoid charges for the next {frequencyText}, cancel before
                the renewal date.
              </li>
            </ul>
            <button
              className="btn-warning btn-lg col-md-6 offset-md-3 center-block py-3 pl-5 pr-5 text-white text-bold border-0 cursor-pointer mb-4"
              type="button"
              onClick={this.updateBillingDetails}
            >
              Complete Payment
            </button>
            <div className="row">
              <img
                src={squarePayment}
                alt="square-payment"
                className="square-payment-icon mb-4"
              />
            </div>
            <div className="toc-review p-4">
              <small>
                By placing this order you agree to our{' '}
                <Link
                  target="_blank"
                  to={ROUTES.TERMS_OF_USE}
                  className="review-link"
                >
                  Terms and Conditions.
                </Link>{' '}
                To ensure continued service, we'll store and update your payment
                method. You may cancel anytime. Prices may change. Learn about
                our Cancellation and Refund policies{' '}
                <Link
                  target="_blank"
                  to={ROUTES.PRIVACY_POLICY}
                  className="review-link"
                >
                  here
                </Link>
              </small>
            </div>
          </div>
        </div>
      </SignUpWrapper>
    );
  }
}

export default withRouter(ReviewSubscription);



// WEBPACK FOOTER //
// ./src/components/transactions/ReviewSubscription.js